import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=4f187d33&scoped=true&"
import script from "./BrandLogo.vue?vue&type=script&lang=ts&"
export * from "./BrandLogo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=4f187d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f187d33",
  null
  
)

export default component.exports